// extracted by mini-css-extract-plugin
export default {"tag_wrapper":"Tag_tag_wrapper__v118d"};